import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CardTitle } from './CardTitle';
import { ReactNode } from 'react';

interface ClaimCardWrapperProps {
  stepIndex: number;
  header: string;
  children?: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [props: string]: any;
}

const Wrapper = styled.div`
  width: 50%;
  display: grid;
  row-gap: 26px;
`;

const ClaimCardWrapper = ({ stepIndex = 0, header = '', children, ...rest }: ClaimCardWrapperProps) => {
  const { t } = useTranslation();

  return (
    <Card {...rest} title={<CardTitle formStepIndex={stepIndex + 1} title={t(header)} />}>
      <Wrapper>{children}</Wrapper>
    </Card>
  );
};

export default ClaimCardWrapper;
